__turbopack_context__.v({
  "container": "ShowcaseBlock-module__8FLi6W__container",
  "fadeInItems": "ShowcaseBlock-module__8FLi6W__fadeInItems",
  "header": "ShowcaseBlock-module__8FLi6W__header",
  "link": "ShowcaseBlock-module__8FLi6W__link",
  "showcase": "ShowcaseBlock-module__8FLi6W__showcase",
  "showcases": "ShowcaseBlock-module__8FLi6W__showcases",
  "spacing--lg": "ShowcaseBlock-module__8FLi6W__spacing--lg",
  "spacing--md": "ShowcaseBlock-module__8FLi6W__spacing--md",
  "spacing--sm": "ShowcaseBlock-module__8FLi6W__spacing--sm",
  "spacing--xl": "ShowcaseBlock-module__8FLi6W__spacing--xl",
  "spacing--xs": "ShowcaseBlock-module__8FLi6W__spacing--xs",
  "spacing--xxl": "ShowcaseBlock-module__8FLi6W__spacing--xxl",
  "spacing--xxs": "ShowcaseBlock-module__8FLi6W__spacing--xxs",
  "spacing--xxxl": "ShowcaseBlock-module__8FLi6W__spacing--xxxl",
  "spacing--xxxs": "ShowcaseBlock-module__8FLi6W__spacing--xxxs",
  "wrapper": "ShowcaseBlock-module__8FLi6W__wrapper",
});
